<template>
	<div class="dankal-image-upload">
		<el-button type="primary" @click='onSelected'>
			<span>导入</span>
		</el-button>
		<input ref="input" type="file" id="file" style="display:none;" :accept="accept" @change="onFileChanged">
	</div>
</template>

<script>
	import ImageCompressor from "image-compressor.js";
	import {
		uploadFile,
		qiniuInfo
	} from "@/api/common";
	import {
		mapState,
		mapActions
	} from "vuex";
	import Utils from "@/jslibs/utils";

	export default {
		name: "DankalFileUpload",
		data() {
			return {};
		},
		created() {},
		props: {
			needUpload: {
				type: Boolean,
				default: false
			},
			accept: {
				type: String,
				default: "*"
			}
		},

		watch: {},
		computed: {
			...mapState(["imgDomain", "bucket_domain_token"])
		},
		mounted() {},

		methods: {
			...mapActions(["getUrlAndTokenOfImageUpload"]),
			onSelected() {
				this.$refs.input.click();
			},
			onFileChanged(event) {
				const file = event.target.files[0];
				// this.getUrlAndTokenOfImageUpload();
				// if (!file) return;
				// if (!this.needUpload) {
				//   this.$emit("change", file);
				// } else {
				//   this.upload(file);
				// }
				this.upload(file);
			},
			async upload(file) {
				//首先获取七牛信息
				const formData = new FormData();
				formData.append("file", file);
				const res = await uploadFile(formData).catch(() => {});
				if (res.status === 200) {
					this.$emit("change", res.data.hash, file.name);
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		.add-box {
			display: flex;
			justify-content: space-around;
			align-items: center;
			width: 120px;
			height: 30px;
			border: 1px solid #e5e5e5;
			border-radius: 6px;
			cursor: pointer;
		}
	}
</style>